/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Admin_Search_By_EmailInputs */

const en_mobile_admin_search_by_email = /** @type {(inputs: Mobile_Admin_Search_By_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search by email`)
};

const es_mobile_admin_search_by_email = /** @type {(inputs: Mobile_Admin_Search_By_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar por email`)
};

/**
* | output |
* | --- |
* | "Search by email" |
*
* @param {Mobile_Admin_Search_By_EmailInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_admin_search_by_email = /** @type {((inputs?: Mobile_Admin_Search_By_EmailInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Admin_Search_By_EmailInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_admin_search_by_email(inputs)
	return en_mobile_admin_search_by_email(inputs)
});